import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { fallbackLng, resources } from './constants'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng,
    resources,
    returnEmptyString: false,
    detection: {
      order: ['querystring', 'navigator'],
    },
  })

export { i18n }
